"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Spinner = function (_a) {
    var isHidden = _a.isHidden, style = _a.style, className = _a.className;
    if (isHidden)
        return null;
    var classNames = "" + (className ? className : '');
    return (react_1.default.createElement(styles_1.default, { className: classNames, style: style },
        react_1.default.createElement("div", { className: "spinner" },
            react_1.default.createElement("div", { className: "double-bounce1" }),
            react_1.default.createElement("div", { className: "double-bounce2" }))));
};
exports.default = Spinner;
//# sourceMappingURL=index.js.map